module.exports = __webpack_public_path__ + "img/amar.05fbe304.jpg";